var render = function (_h,_vm) {var _c=_vm._c;return _c('b-tooltip',{attrs:{"label":_vm.props.value.length > 23 ? _vm.props.value : ''}},[_c('div',_vm._b({class:_vm.props.value.length > 23 ? 'truncate' : ''},'div',_vm.data.attrs,false),[_vm._v(" "+_vm._s(_vm.props.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }